export default {"src":"/_next/static/media/visual-search.6956b3a4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};